const INITIAL_VISIBLE_COLUMNS = ["title", "agent", "date", "quality", "actions"];
const columns = [
  { name: "id", uid: "id" },
  { name: "Title", uid: "title" },
  // { name: "User", uid: "user" },
  { name: "Advisor Name", uid: "agent" },
  { name: "Posted Date", uid: "date" },
  { name: "Feedback", uid: "quality" },
  { name: "Actions", uid: "actions" },
];
const KNOWLEDGE_COLUMNS = [
  { name: "id", uid: "id" },
  { name: "File Name", uid: "file_name" },
  { name: "Progress", uid: "progress" },
  { name: "Status", uid: "status" },
  { name: "Size", uid: "size" },
  { name: "Date", uid: "date" },
  { name: "File Type", uid: "type" },
  { name: "Actions", uid: "actions" },
];
const ID_CONSTANTS = {
  chatAdvisorLogo: "chat-advisor-logo",

  chatAdvisorName: "chat-advisor-name",
  chatAdvisorDescription: "chat-advisor-description",
  converseImageUploadBtn: "converse-image-upload-btn",
  chatSpeechLanguageBtn: "chat-speech-language-btn-",
  chatTextTransformBtn: 'chat-text-transform-btn',
  chatSpeakBtn: 'chatspeak-btn',
  chatFileBtn: 'chatfile-btn',
  sessionId: "session-id-",
  knowledgeSourceText: "knowledge-source-text",
  expertSource: "expert-source-",
  viewSource: "view-source-",
  logoLabel: "logo-label",
  trainKnowledgeText: "trainknowledge-text",
  trainUrlText: "trainurl-text",
  urlSearchInput: "urlsearch-input",
  groupBtn: "group-btn",
  cancelUrlBtn: "cancel-url-btn",
  uploadUrlBtn: "upload-url-btn",
  fileName: "filename-",
  knowledgeTableRefreshBtn: "knowledgetable-refresh-btn",
  knowledgeTableMetadataColumnsBtn: "knowledgetable-metadata-columns-btn",
  knowledgeTableUpdateBtn: "knowledgetable-update-btn",
  uploadCard: "-upload-card",
};

const FILE_TYPE_COLOR = {
  "Documents": "bg-[#6689AF]",
  "Spreadsheets": "bg-[#FDA29B]",
  "Presentations": "bg-[#FEC84B]",
  "Web Links": "bg-[#75E0A7]",
  "Media": "bg-[#B3B8DB]"
};

const KNOWLEDGE_INITIAL_VISIBLE_COLUMNS = ["file_name", "progress", "date", "status", "size", "type", "actions"];

const SourceElementType = Object.freeze({
  TEXT: "text",
  TABLE: "table",
  URL: "url",
  YOUTUBE: "youtube",
  AUDIO: [
    "mp3", "wav", "aac", "ogg", "flac", "m4a", "wma", "opus", "aiff", "alac", "amr"
  ],
  VIDEO: [
    "mp4", "mkv", "avi", "mov", "flv", "wmv", "webm", "mpeg", "mpg", "3gp", "ogv"
  ],
  IMAGE: "image",
  EXPERT_ANSWER: "expert_answer",
  KNOWLEDGE_ARTICLE: "knowledge_article",
  EXCEL: "excel",
  API: "api",
  PARTS_SVG: "parts_svg",
  MP3: "mp3",
  MP4: "mp4",
  ZIP: "zip",
  PARTS_ZIP: "parts_zip",
  SVG: "svg",
  DITAMAP: "ditamap",
});

const azureSupportedLanguages =
{
  "af-ZA": "Afrikaans",
  "am-ET": "Amharic",
  "ar-SA": "Arabic",
  "as-IN": "Assamese",
  "az-AZ": "Azerbaijani",
  "ba-RU": "Bashkir",
  "bg-BG": "Bulgarian",
  "bho-IN": "Bhojpuri",
  "bn-IN": "Bangla",
  "bo-CN": "Tibetan",
  "brx-IN": "Bodo",
  "bs-BA": "Bosnian",
  "ca-ES": "Catalan",
  "cs-CZ": "Czech",
  "cy-GB": "Welsh",
  "da-DK": "Danish",
  "de-DE": "German",
  "doi-IN": "Dogri",
  "dsb-DE": "Lower Sorbian",
  "dv-MV": "Divehi",
  "el-GR": "Greek",
  "en-US": "English",
  "es-ES": "Spanish",
  "et-EE": "Estonian",
  "eu-ES": "Basque",
  "fa-IR": "Persian",
  "fi-FI": "Finnish",
  "fil-PH": "Filipino",
  "fj-FJ": "Fijian",
  "fo-FO": "Faroese",
  "fr-FR": "French",
  "fr-CA": "French (Canada)",
  "ga-IE": "Irish",
  "gl-ES": "Galician",
  "gom-IN": "Konkani",
  "gu-IN": "Gujarati",
  "ha-NG": "Hausa",
  "he-IL": "Hebrew",
  "hi-IN": "Hindi",
  "hne-IN": "Chhattisgarhi",
  "hr-HR": "Croatian",
  "hsb-DE": "Upper Sorbian",
  "ht-HT": "Haitian Creole",
  "hu-HU": "Hungarian",
  "hy-AM": "Armenian",
  "id-ID": "Indonesian",
  "ig-NG": "Igbo",
  "ikt-CA": "Inuinnaqtun",
  "is-IS": "Icelandic",
  "it-IT": "Italian",
  "iu-CA": "Inuktitut",
  "iu-Latn-CA": "Inuktitut (Latin)",
  "ja-JP": "Japanese",
  "ka-GE": "Georgian",
  "kk-KZ": "Kazakh",
  "km-KH": "Khmer",
  "kmr-TR": "Kurdish (Northern)",
  "kn-IN": "Kannada",
  "ko-KR": "Korean",
  "ks-IN": "Kashmiri",
  "ku-IQ": "Kurdish (Central)",
  "ky-KG": "Kyrgyz",
  "ln-CD": "Lingala",
  "lo-LA": "Lao",
  "lt-LT": "Lithuanian",
  "lug-UG": "Ganda",
  "lv-LV": "Latvian",
  "lzh-CN": "Chinese (Literary)",
  "mai-IN": "Maithili",
  "mg-MG": "Malagasy",
  "mi-NZ": "Māori",
  "mk-MK": "Macedonian",
  "ml-IN": "Malayalam",
  "mn-Cyrl-MN": "Mongolian (Cyrillic)",
  "mn-Mong-CN": "Mongolian (Traditional)",
  "mni-IN": "Manipuri",
  "mr-IN": "Marathi",
  "ms-MY": "Malay",
  "mt-MT": "Maltese",
  "mww-CN": "Hmong Daw",
  "my-MM": "Myanmar (Burmese)",
  "nb-NO": "Norwegian",
  "ne-NP": "Nepali",
  "nl-NL": "Dutch",
  "nso-ZA": "Sesotho sa Leboa",
  "nya-MW": "Nyanja",
  "or-IN": "Odia",
  "otq-MX": "Querétaro Otomi",
  "pa-IN": "Punjabi",
  "pl-PL": "Polish",
  "prs-AF": "Dari",
  "ps-AF": "Pashto",
  "pt-BR": "Portuguese (Brazil)",
  "pt-PT": "Portuguese (Portugal)",
  "ro-RO": "Romanian",
  "ru-RU": "Russian",
  "run-BI": "Rundi",
  "rw-RW": "Kinyarwanda",
  "sd-PK": "Sindhi",
  "si-LK": "Sinhala",
  "sk-SK": "Slovak",
  "sl-SI": "Slovenian",
  "sm-WS": "Samoan",
  "sn-ZW": "Shona",
  "so-SO": "Somali",
  "sq-AL": "Albanian",
  "sr-Cyrl-RS": "Serbian (Cyrillic)",
  "sr-Latn-RS": "Serbian (Latin)",
  "st-ZA": "Sesotho",
  "sv-SE": "Swedish",
  "sw-TZ": "Swahili",
  "ta-IN": "Tamil",
  "te-IN": "Telugu",
  "th-TH": "Thai",
  "ti-ET": "Tigrinya",
  "tk-TM": "Turkmen",
  "tlh-Latn-XX": "Klingon (Latin)",
  "tlh-Piqd-XX": "Klingon (pIqaD)",
  "tn-BW": "Setswana",
  "to-TO": "Tongan",
  "tr-TR": "Turkish",
  "tt-RU": "Tatar",
  "ty-PF": "Tahitian",
  "ug-CN": "Uyghur",
  "uk-UA": "Ukrainian",
  "ur-PK": "Urdu",
  "uz-UZ": "Uzbek (Latin)",
  "vi-VN": "Vietnamese",
  "xh-ZA": "Xhosa",
  "yo-NG": "Yoruba",
  "yua-MX": "Yucatec Maya",
  "yue-CN": "Cantonese (Traditional)",
  "zh-Hans-CN": "Chinese Simplified",
  "zh-Hant-TW": "Chinese Traditional",
  "zu-ZA": "Zulu"
};

enum promptInputType {
  TEXTAREA = 'Textarea',
  INPUT = 'Input'
}

type UploadedFileType = {
  size: string;
  name: string;
  type: string;
  uploading: boolean;
  file: File;
  source_id?: string;
};

const agGridToApiCondition: Record<string, string> = {
  // Text filters
  contains: 'contains',
  notContains: 'does_not_contain',
  equals: 'equals',
  notEqual: 'does_not_equal',
  startsWith: 'begins_with',
  endsWith: 'ends_with',

  // Special cases
  blank: 'equals',      // treat blank as equals null/empty
  notBlank: 'does_not_equal', // treat not blank as does_not_equal null/empty

  // Set filters
  inRange: 'in',
  notInRange: 'not_in',
};

type AgGridFilterCondition = { type?: string; filter?: unknown };

/** Turn one AG Grid column filter into API filters. OR groups same conditions into value arrays; AND stays separate objects. */
function appendAgGridConditionsToApiFilters(
  filters: Record<string, unknown>[],
  field: string,
  filter: {
    operator?: string;
    conditions?: AgGridFilterCondition[];
    condition1?: AgGridFilterCondition;
    condition2?: AgGridFilterCondition;
    type?: string;
    filter?: unknown;
  } | null | undefined,
) {
  if (!filter) return;

  const listed = Array.isArray(filter.conditions) && filter.conditions.length
    ? filter.conditions
    : [filter.condition1, filter.condition2].filter((c): c is AgGridFilterCondition => !!c);
  const conditions: AgGridFilterCondition[] = listed.length ? listed : [filter];

  const normalized = conditions
    .map((c) => {
      const type = c.type;
      const value = type === 'blank' || type === 'notBlank' ? null : c.filter;
      return { condition: agGridToApiCondition[type || ''] || 'contains', value };
    })
    .filter((c) => c.value !== undefined && c.value !== '');

  if (!normalized.length) return;

  const isOr = String(filter.operator || '').toUpperCase() === 'OR' && normalized.length > 1;
  if (!isOr) {
    for (const c of normalized) filters.push({ [field]: c.value, condition: c.condition });
    return;
  }

  const groups = new Map<string, unknown[]>();
  for (const c of normalized) {
    const values = groups.get(c.condition) ?? [];
    values.push(c.value);
    groups.set(c.condition, values);
  }
  for (const [condition, values] of groups) {
    filters.push({ [field]: values.length > 1 ? values : values[0], condition });
  }
}

const enum ApplicationType {
  WIDGET = 'widget',
  BROWSER_EXTENSION = 'browser_extension',
  WEB = 'web',
}

const isBrowserExtension = ['chrome-extension:', 'moz-extension:'].includes(window.location.protocol);
const isWidget = window.self !== window.top || new URLSearchParams(window.location.search).get('widget') === 'true';

const applicationType = (): ApplicationType => {
  if (isWidget) {
    return ApplicationType.WIDGET;
  } else if (isBrowserExtension) {
    return ApplicationType.BROWSER_EXTENSION;
  } else {
    return ApplicationType.WEB;
  }
}

const isCompactApplicationType = (): boolean => {
  const appType = applicationType();
  return appType === ApplicationType.WIDGET || appType === ApplicationType.BROWSER_EXTENSION;
};

// Email constants for share conversation functionality
const EMAIL_CONSTANTS = {
  VALIDATION_REGEX: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  SUBJECT_TEMPLATE: (senderName: string) => `${senderName} has shared a conversation with you`,
  BODY_TEMPLATE: (shareUrl: string, inviteUserName: string) => `Hi ${inviteUserName},\n\nI wanted to share this conversation with you. You can view it at the following link:\n\n${shareUrl}\n\nBest regards`,
  PLACEHOLDER_EMAIL: "olivia@untitledui.com",
  COPY_RESET_TIMEOUT: 2000, // 2 seconds
};

export { INITIAL_VISIBLE_COLUMNS, columns, KNOWLEDGE_COLUMNS, KNOWLEDGE_INITIAL_VISIBLE_COLUMNS, ID_CONSTANTS, azureSupportedLanguages, promptInputType, SourceElementType, UploadedFileType, FILE_TYPE_COLOR, EMAIL_CONSTANTS, isBrowserExtension, agGridToApiCondition, appendAgGridConditionsToApiFilters, applicationType, isCompactApplicationType, ApplicationType };